import { AlertActions, AlertActionTypes, HideAlert, ShowAlert } from '@app/core/actions/alert';
import { AlertMessage } from '@app/core/models/alert/alert-message';
import { createHandler, createReducer } from '@app/util';
import * as R from 'ramda';

export interface State {
  alerts: AlertMessage[];
}

export const initialState: State = {
  alerts: []
};

const showAlertHandler = createHandler(AlertActionTypes.ShowAlert, (state: State, action: ShowAlert) => {
  const alertExists = R.indexOf(action.payload, state.alerts) >= 0;
  return alertExists
    ? state
    : R.mergeRight(state, {alerts: R.append(action.payload, state.alerts)});
}
);

const hideAlertHandler = createHandler(AlertActionTypes.HideAlert, (state: State, action: HideAlert) =>
  R.mergeRight(state, {
    alerts: R.reject((alert) =>
      alert === action.payload,
    state.alerts
    )
  })
);

const hideAllAlertsHandler = createHandler(AlertActionTypes.HideAllAlerts, (state: State) =>
  R.mergeRight(state, {
    alerts: []
  })
);

export const reducer = createReducer<State, AlertActions>([
  showAlertHandler,
  hideAlertHandler,
  hideAllAlertsHandler
], initialState);

export const getAlerts = (state: State) => state.alerts;
